import type { GA4ProductType } from '@/ga4types'

import type { AbandonedSelection, HotelDealMatch, PackageTypeCode } from './types'

const packageTypeCodeMap = {
  A: 'a',
  AH: 'ha',
  AC: 'ac',
  AHC: 'hac',
  ACH: 'hac',
} as const

function getLabelFromProductType(productType: string) {
  switch (productType) {
    case 'STAY':
      return 'hotel'
    case 'FLY':
      return 'air'
    case 'DRIVE':
      return 'car'
    default:
      return ''
  }
}

function mapPackageTypeCode(code: PackageTypeCode) {
  return packageTypeCodeMap[code]
}

function getRecentSelectionLabel(selection: AbandonedSelection) {
  if (selection.productType === 'hotels') {
    switch (selection.hotelDealType) {
      case 'RtlHotel':
        return 'hotel'
      case 'SopqHotel':
        return 'hotel express deal'
      case 'AbandonedPriceBreakersHotel':
        return 'hotel pricebreaker'
      default:
        return ''
    }
  } else if (selection.productType === 'cars') {
    return 'car'
  } else if (selection.productType === 'flights') {
    return 'air'
  } else if (selection.productType === 'packages') {
    return 'bundle'
  }
  return ''
}

function getSelectionItemId(selection: AbandonedSelection): string {
  if (selection.productType === 'hotels') {
    return selection.id ?? ''
  }
  return ''
}

function getSelectionCurrency(selection: AbandonedSelection): string {
  if (selection.productType === 'hotels') {
    return selection.hotelTotalPriceWithTaxesAndFeesAtAbandonment?.currencyCode ?? ''
  }
  return ''
}

function getSimilarHotelEcommerceCurrency(hotel: HotelDealMatch): string {
  return hotel.reference.ratesSummary?.minCurrencyCodeSymbol ?? '$'
}

function getSimilarHotelsLoadEcommerceCurrency(displayedHotels: readonly HotelDealMatch[]): string {
  return getSimilarHotelEcommerceCurrency(displayedHotels[0])
}

function getSelectionProductName(productType: string): GA4ProductType {
  switch (productType) {
    case 'packages':
      return 'bundle'
    case 'flights':
      return 'air'
    case 'cars':
      return 'car'
    default:
      return 'hotel'
  }
}

export {
  getLabelFromProductType,
  mapPackageTypeCode,
  getRecentSelectionLabel,
  getSelectionItemId,
  getSelectionCurrency,
  getSimilarHotelEcommerceCurrency,
  getSimilarHotelsLoadEcommerceCurrency,
  getSelectionProductName,
}
